import _ from 'lodash';
import { getCountry } from '../../iwIntlProvider/CountryProvider';
import { GetPaymentMethodResponse } from '@iwoca/lapi-client/v1';

type TPaymentMethod = GetPaymentMethodResponse['data'];

export function getPaymentMethod(
    payment_method: TPaymentMethod,
    paymentMethodID: string
) {
    return _.find(payment_method, { payment_method_id: paymentMethodID });
}

export function calculateRepaymentRole(payment_method: TPaymentMethod) {
    const hasExistingPrimaryCard = !!_.chain(payment_method)
        .filter((payment) => payment.payment_method_type === 'card')
        .find((payment) => payment.roles.repayment === 'primary')
        .value();

    if (!hasExistingPrimaryCard) {
        return 'primary';
    }

    return null;
}

export function serialiseBankAccountData(bankAccountData: {
    iban: string;
    accountNumber: string;
    sortCode: string;
}) {
    let bankAccountInformation;

    if (getCountry() === 'DE') {
        bankAccountInformation = {
            iban: bankAccountData.iban
        };
    }

    if (getCountry() === 'UK') {
        bankAccountInformation = {
            account_number: bankAccountData.accountNumber,
            sort_code: bankAccountData.sortCode
        };
    }

    return {
        bank_details: {
            ...bankAccountInformation
        },
        roles: {
            funding: 'enabled',
            repayment: 'disabled'
        }
    };
}

export function isValidCardType(
    paymentMethod: TPaymentMethod[number],
    acceptedCardTypes: string[]
) {
    // @ts-expect-error paymentMethod.card isn't in the schema.
    return _.includes(acceptedCardTypes, paymentMethod.card.funding);
}
